var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTvAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 27L8 32",
    stroke: "#BEAE79",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 6H2C0.89543 6 0 6.89543 0 8V28C0 29.1046 0.89543 30 2 30H34C35.1046 30 36 29.1046 36 28V8C36 6.89543 35.1046 6 34 6Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27L33 32",
    stroke: "#BEAE79",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6H34C35.1046 6 36 6.8954 36 8V27C36 28.6569 34.6569 30 33 30H20L11 6Z",
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.998 17.8875C25.3913 17.4942 25.8582 17.1822 26.3721 16.9694C26.886 16.7565 27.4367 16.647 27.9929 16.647C28.5491 16.647 29.0999 16.7565 29.6138 16.9694C30.1276 17.1822 30.5945 17.4942 30.9878 17.8875",
    stroke: "#BEAE79",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.861C25.9808 13.3797 30.0033 13.3797 32.5 15.861",
    stroke: "#BEAE79",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9905 20.3525C28.2991 20.3525 28.5493 20.1023 28.5493 19.7937C28.5493 19.4851 28.2991 19.2349 27.9905 19.2349C27.6818 19.2349 27.4316 19.4851 27.4316 19.7937C27.4316 20.1023 27.6818 20.3525 27.9905 20.3525Z",
    fill: "#BEAE79",
    stroke: "#BEAE79"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 27.5L19 19",
    stroke: "#BEAE79",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27.5L38 19",
    stroke: "#BEAE79",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38 26H18C16.8954 26 16 26.8954 16 28V32C16 33.1046 16.8954 34 18 34H38C39.1046 34 40 33.1046 40 32V28C40 26.8954 39.1046 26 38 26Z",
    fill: "#BEAE79"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28 26H38C39.1046 26 40 26.8954 40 28V32C40 33.1046 39.1046 34 38 34H28V26Z",
    fill: "#EEE0AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 29.5V30.5",
    stroke: "#BEAE79",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34 29.5V30.5",
    stroke: "#BEAE79",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 29.5V30.5",
    stroke: "#BEAE79",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9996 16.8365C11.182 17.0233 11.2842 17.2741 11.2842 17.5352V26C11.2842 26.5523 10.8365 27 10.2842 27H3.71289C3.16061 27 2.71289 26.5523 2.71289 26V16C2.71289 15.4477 3.16061 15 3.71289 15H8.78489C9.05421 15 9.31215 15.1086 9.50032 15.3013L10.9996 16.8365Z",
    fill: "#BEAE79"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.48438,
    y: 20.2163,
    width: 6.9316,
    height: 6.21643,
    rx: 0.5,
    fill: "#EEE0AF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.92578,
    y: 20.6562,
    width: 1.70539,
    height: 3.19074,
    fill: "#BEAE79"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.125,
    y: 20.6562,
    width: 1.65038,
    height: 1.48534,
    fill: "#BEAE79"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.125,
    y: 24.5068,
    width: 1.65038,
    height: 1.48534,
    fill: "#BEAE79"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.92578,
    y: 24.5068,
    width: 1.76041,
    height: 1.48534,
    fill: "#BEAE79"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3.92578,
    y: 22.5815,
    width: 6.0514,
    height: 1.48534,
    fill: "#BEAE79"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.27148,
    y: 20.6562,
    width: 1.70539,
    height: 1.48534,
    fill: "#BEAE79"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2168,
    y: 24.5068,
    width: 1.76041,
    height: 1.48534,
    fill: "#BEAE79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTvAdd);
export default __webpack_public_path__ + "static/media/icon_tv_add.300899f0b40dcf6e1566ed159cbbe251.svg";
export { ForwardRef as ReactComponent };